'use strict';

const TS = require("@zerolight/zlthunder-time-utils");
const numeral = require('numeral');
const moment = require('moment');
const {words, capitalize} = require('lodash');

function safeNumber(n) {
	n = Number(n);
	return !isNaN(n) ? n : null;
}

function safeMinutes(n) {
	n = safeNumber(n);
	return n !== null ? Math.ceil(n / TS.MINUTE) : null;
}

const DateFormat = 'YYYY-MM-DD';
const PrettyDateFormat = 'DD MMM YYYY';
const DateTimeFormat = 'YYYY-MM-DD h:mm a';
const IntFormat = '0,0';
const NumberFormat = '0,0.00';

function formatDate(value, format) {
	value = TS.validate(value);
	if (!value) {
		return null;
	}

	if (format) {
		return moment(value).utc().format(format);
	}

	let hours = value.getUTCHours();
	let minutes = value.getUTCMinutes();
	if (hours || minutes) {
		format = DateTimeFormat;
	} else {
		format = DateFormat;
	}
	return moment(value).utc().format(format);
}

function formatNumber(value, format) {
	let n = Number(value);
	if (isNaN(n)) {
		return value;
	}
	if (!value) {
		return null;
	}
	return numeral(n).format(format || numeral.defaultFormat);
}

function formatMinutes(value, numberFormat = IntFormat) {
	value = safeNumber(value);
	if (value) {
		value = Math.round(value);
		let m = numeral(Math.floor(value / 60)).format(numberFormat);
		let sec = String(value % 60).padStart(2, '0');
		return `${m}:${sec}`;
	}
	return null;
}

function formatString(value) {
	if (value === null) {
		return null;
	} else {
		return String(value);
	}
}

function pretty(value) {
	return words(value).map(capitalize).join(' ');
}

function getValue(obj, getter) {
	if (!obj) {
		return null;
	}
	if (!(getter instanceof Function)) {
		let key = getter;
		getter = (s => (s && s.hasOwnProperty(key) ? s[key] : null));
	}
	return getter(obj);
}

function formatValue(obj, getter, formatter = formatString) {
	let v = getValue(obj, getter);
	return formatter(v);
}

module.exports = {
	safeNumber, safeMinutes, formatDate, formatNumber, formatMinutes,
	getValue, formatValue, pretty,
	PrettyDateFormat, DateFormat, DateTimeFormat, IntFormat, NumberFormat
};
